/**
 * Type: ユーティリティーパーツ
 * What: XSS対策のためにjavascript文字列をエスケープする
 */

const HtmlEscape = (content) => content.replace(/javascript:/g, '');

export default HtmlEscape;
